module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="form-group row">\n    <label class="DescartesUILabel col-sm-6 col-form-label">' +
((__t = (labelTtl)) == null ? '' : __t) +
'</label>\n    <div class="col-sm-6">\n		<select id="DescartesShareLinkTTL" class="DescartesUISelect form-control">\n		    ';

		       _.each(listTtl,function(ttl) {
		            if (ttl.value === defaultTtl) {
		               print('<option value="'+ ttl.value +'" selected>' + ttl.label + '</option>');
		            } else {
		               print('<option value="'+ ttl.value +'">' + ttl.label + '</option>');
		            }
		            
		       })
		    ;
__p += '\n        </select>\n    </div>\n</div>\n<button class="DescartesUIButton btn ' +
((__t = (btnCss)) == null ? '' : __t) +
' form-control" id="DescartesShareLinkGenerateBtn">' +
((__t = (labelBtnGenerate)) == null ? '' : __t) +
'</button>\n<br />\n<br />\n<div class="form-group">\n  <label id="DescartesShareLinkLabel" class="DescartesUILabel">' +
((__t = (labelLink)) == null ? '' : __t) +
'</label><br />\n  <div class="row">\n    <div class="col-10">\n      <input type="url" value="" id="DescartesShareLinkInputUrl" class="DescartesUIShareLinkInputUrl" readonly>\n    </div>\n    <div class="col-2">\n      <button type="button" class="DescartesUIButton btn ' +
((__t = (btnCss)) == null ? '' : __t) +
'" id="DescartesShareLinkCopyBtn"><i class="fa fa-clone"></i></button>\n    </div>\n  </div>\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/Button/bootstrap4/templates/ShareLinkMap.ejs
// module id = 426
// module chunks = 0